import type { AssignRiderRequest, Order } from '../api/admin-orders';

export type AssignRiderMode = 'assign_only' | 'assign_and_send_out';

export function buildAssignRiderRequest(
  order: Pick<Order, 'version'>,
  riderId: string,
  adminId: string,
  mode: AssignRiderMode
): AssignRiderRequest {
  const sendOutNow = mode === 'assign_and_send_out';

  return {
    rider_id: riderId,
    admin_id: adminId,
    notes: sendOutNow
      ? 'Assigned and sent out via admin dashboard'
      : 'Assigned via admin dashboard',
    send_out_now: sendOutNow,
    expected_version: order.version,
  };
}
